/**
 * KeyCloakUtils
 *
 * From: 1.0.0
 * @packageDocumentation
 */

import Keycloak from 'keycloak-js';

import { env } from './EnvUtils';

const MIN_VALIDITY = 10; // token refresh 開始残り時間(秒)
const keycloak = new Keycloak(
  `${env.APP_ROOT}/${env.ENVIRONMENT}/keycloak.json`
);

export const getIdToken = () => keycloak.idToken;
export const getParsedIdToken = () => keycloak.idTokenParsed;
export const getToken = () => keycloak.token;
export const getParsedToken = () => keycloak.tokenParsed;
export const isLoggedIn = () => !!keycloak.token;
export const updateToken = (minValidity: number = MIN_VALIDITY) =>
  keycloak
    .updateToken(minValidity)
    .then(() => Promise.resolve(true))
    .catch(keycloak.login);
export const hasRole = (roles: string[]) =>
  roles.some((role) => keycloak.hasRealmRole(role));

export default keycloak;
